import { bsc } from 'wagmi/chains';
import { TARGET_CHAIN } from './config';

// Modules deferred from the initial mainnet launch (see docs/audit-prep.md).
//
// The current PelagosBridge is a lock&mint *demo* — it emits an event string as
// the "target chain" and has no cross-chain messaging, validators, finality or
// replay protection. The external audit recommends launching Swap/Pools only, so
// Bridge is hidden on mainnet until a real messaging protocol (LayerZero / CCIP)
// is integrated and separately audited. It stays fully usable on testnet for demos.
const DEFERRED_AT_MAINNET: readonly string[] = ['Bridge'];

const isMainnet = (TARGET_CHAIN.id as number) === bsc.id;

/** True when a nav view should be gated as "coming soon" for the live launch. */
export function isDeferredAtLaunch(view: string): boolean {
  return isMainnet && DEFERRED_AT_MAINNET.includes(view);
}
